@if (label()) {
    <div class="vds-form-field-label-wrapper">
        <label class="vds-form-field-label" [attr.for]="formFieldControl()?.id()">
            <ng-content select="vds-label" />
        </label>

        @if (optionalLabel()) {
            <div class="vds-form-field-optional-label">{{ optionalLabel() }}</div>
        }
    </div>
}

<div class="vds-content-wrapper">
    <div
        #textField
        class="vds-text-field-wrapper"
        [class.vds-text-field--disabled]="formFieldControl()?.disabledState()"
        [class.vds-text-field--focused]="formFieldControl()?.focused()"
        [class.vds-text-field--readonly]="formFieldControl()?.isReadonly()"
        (click)="formFieldControl()?.onContainerClick($event)"
    >
        <div class="vds-form-field-flex">
            @if (hasLeadingIcon()) {
                <ng-container *polymorpheusOutlet="leadingIcon() as primitive">
                    <div class="vds-form-field-icon-prefix">
                        <vds-icon [name]="primitive" />
                    </div>
                </ng-container>
            }
            <div class="vds-form-field-input">
                <ng-content />
            </div>
            @if (showClearButton()) {
                <div class="vds-form-field-clear">
                    <button type="button" class="vds-form-field-clear-button" [attr.aria-label]="clearLabel()" (click)="clear($event)">
                        <vds-icon name="close-filled" />
                    </button>
                </div>
            }
            @if (hasTrailingIconComputed()) {
                <ng-container *polymorpheusOutlet="effectiveTrailingIcon() as primitive">
                    <div class="vds-form-field-icon-suffix">
                        <vds-icon [name]="primitive" />
                    </div>
                </ng-container>
            }
        </div>
    </div>
    <ng-content select="[vds-icon-button]" />
</div>

@if (hasMessages()) {
    <div aria-atomic="true" aria-live="polite" class="vds-form-field__messages-wrapper">
        @switch (displayedMessages()) {
            @case ("error") {
                <div class="vds-message-wrapper">
                    <ng-content select="vds-error" />
                </div>
            }

            @case ("hint") {
                @if (hintChildren().length > 0) {
                    <div class="vds-message-wrapper">
                        <ng-content select="vds-hint" />
                    </div>
                }
            }
        }
    </div>
}
